import * as React from 'react';
import * as Styled from './styled';
import {
    Input,
    IconButton,
    withStyles,
    Tooltip,
    CircularProgress,
    Collapse
} from '@material-ui/core';
import {
    Add,
    Search,
    FlipToBack,
    FlipToFront,
    KeyboardArrowUp,
    KeyboardArrowDown,
    Today,
    Loop,
    Sort as SortIcon,
    AddAlarm
} from '@material-ui/icons';
import { inject, observer } from 'mobx-react';
import { RootStore } from 'store/root.store';
import { Route } from 'react-router';
import TemplateFormContainer from './TimerContainer';
import TimerStore from 'store/Timer/timer.store';
import styled from 'common/styled-components';
import { parseCode } from 'util/utils';
import { Client, Matter, Features, TimeKeeperAssignment } from '../../api/types/types';
import AutoCompleteField from 'components/AutoCompleteField';
import { ApiConsumer } from 'common/ApiProvider';
import RootAPI from '../../api/interfaces/RootAPI';
import TimerLink from './TimerLink';
import { TKConsumer } from 'common/TKProvider';
import { AutoSizer, List, ListRowProps } from 'react-virtualized';
import { withTranslation } from 'react-i18next';
import { LoadingDiv } from 'containers/Home/Home';
import { GeneralNavigationHotKeys, handleEscapeKey } from 'util/hotKeys';
import { getMatterTooltipText } from 'util/timeEntry';
import { MatterItemFormatter } from 'components/TemplateForm/TemplateForm';
import { useTranslation } from 'react-i18next';
import { RootStoreContext } from '../../App';

interface Props {
    rootStore?: RootStore;
    timerStore?: TimerStore;
    location: {
        pathname: string;
    };
    match: {
        url: string;
    };
    // tslint:disable:no-any
    classes: any;
    t: any;
    // tslint:enable:no-any
}
interface GGProps extends ListRowProps {
    timerStore?: TimerStore;
    handleKeyboardAction: (fromKeyboard: boolean) => void;
    buttonRef?: React.RefObject<HTMLElement>;
}
interface State {
    expanded: boolean;
    scrollToTop: number | undefined;
}
export const FabProgress = styled(CircularProgress)`
    position: absolute;
    top: -6;
    left: -6;
    z-index: 1;
`
const styles = () => ({
    button: {
        '&:hover': {
            backgroundColor: 'none'
        },
        backgroundColor: 'white',
        marginRight: 36,
        opacity: 0.9,
        width: 36,
        height: 36,
        padding: 0
    },
    defaultButton: {
        '&:hover': {
            backgroundColor: 'white',
            opacity: 0.9
        },
        backgroundColor: 'none',
        marginRight: 36,
        width: 36,
        height: 36,
        padding: 0
    }
});

class ListRow extends React.Component<GGProps> {
    render() {
        const { index, key, style, timerStore, buttonRef, handleKeyboardAction } = this.props;
        const {
            selectedTimer,
            loadingTimer,
            filteredTimers,
            changeSelectedTimer,
            startTimer,
            stopTimer,
            deleteTimer,
            addTimerNote,
            isActiveToday,
            rootStore
        } = timerStore!;
        const includeSubmitted = rootStore.appStore.features.EpochConfigTimeSegmentsSubmittedVisible;
        const timer = filteredTimers[index];

        return (
            <div
                key={key}
                style={style}
                onClick={() => {
                    rootStore.appStore.setPreviousActiveElement();
                    changeSelectedTimer(timer.id);
                }}
            >
                <TimerLink
                    buttonRef={buttonRef}
                    key={timer.id!.toString()}
                    timer={timer}
                    selected={selectedTimer && selectedTimer.id === timer.id}
                    onDelete={() => {
                        rootStore.appStore.setPreviousActiveElement();
                        deleteTimer(timer);
                    }}
                    onStart={async (fromKeyboard) => {
                        await startTimer(timer);
                        handleKeyboardAction(fromKeyboard);
                    }}
                    onStop={async (fromKeyboard) => {
                        await stopTimer(timer.id!);
                        handleKeyboardAction(fromKeyboard);
                    }}
                    loadingId={loadingTimer}
                    includeSubmitted={includeSubmitted}
                    disableDelete={timer.active}
                    onAddNote={addTimerNote}
                    isActiveToday={isActiveToday(timer)}
                    style={style}
                />
            </div>
        );
    }
}

export const DailyTimerTotals = observer(() => {
    const { timerStore } = React.useContext(RootStoreContext);
    const { t } = useTranslation(['timers', 'common']);

    const [, setTick] = React.useState(0);

    React.useEffect(() => {
        const interval = setInterval(() => {
            if (timerStore.timers.some(timer => timer.active)) {
                setTick(tick => tick + 1);
            }
        }, 250);

        return () => clearInterval(interval);
    }, []);

    const { total, unsubmitted, submitted } = timerStore.getTodayDurations();

    return (
        <Styled.DailyTimerHeader>
            <Styled.DailyTimerToday>
                {t('today_timer_header.title')}
            </Styled.DailyTimerToday>
            <Styled.DailyTimerSection>
                <Styled.DailyTimerLabel>{t('today_timer_header.total')}</Styled.DailyTimerLabel>
                <Styled.DailyTimerValue>{total}</Styled.DailyTimerValue>
            </Styled.DailyTimerSection>
            <Styled.DailyTimerSection>
                <Styled.DailyTimerLabel>{t('today_timer_header.unsubmitted')}</Styled.DailyTimerLabel>
                <Styled.DailyTimerValue colorType="primary">{unsubmitted}</Styled.DailyTimerValue>
            </Styled.DailyTimerSection>
            <Styled.DailyTimerSection>
                <Styled.DailyTimerLabel>{t('today_timer_header.submitted')}</Styled.DailyTimerLabel>
                <Styled.DailyTimerValue>{submitted}</Styled.DailyTimerValue>
            </Styled.DailyTimerSection>
        </Styled.DailyTimerHeader>
    );
});
@inject((allStores: { rootStore: RootStore }) => {
    let rootStore = allStores.rootStore;
    return {
        rootStore: rootStore,
        timerStore: rootStore.timerStore
    };
})
@observer
class Timers extends React.Component<Props, State> {
    activeButtonRef = React.createRef<HTMLElement>();
    rightPanelRef = React.createRef<HTMLElement>();
    fabRef = React.createRef<HTMLElement>();
    fabButtonRef = React.createRef<HTMLElement>();

    constructor(props: Props) {
        super(props);
        this.state = {
            expanded: false,
            scrollToTop: undefined
        }
    }
    componentDidMount() {
        this.props.timerStore!.setClientFilterValue();
        this.props.timerStore!.setMatterFilterValue();
        this.props.timerStore!.resetTodayTimerFlag();
        this.props.timerStore!.loadTimers();
    }
    componentWillUnmount() {
        this.props.timerStore!.onSearchChange('');
        this.props.timerStore!.setClientFilterValue();
        this.props.timerStore!.setMatterFilterValue();
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>) {
        const { location, timerStore } = this.props;
        if (location.pathname === '/timers' && location.pathname !== prevProps.location.pathname) {
            timerStore!.resetSelectedTimer([]);
        }
        if (this.state.scrollToTop !== prevState.scrollToTop ) {
            if (this.state.scrollToTop === 0) {
                this.setState({ scrollToTop: undefined});
            } else if (this.activeButtonRef.current) {
                this.activeButtonRef.current.focus();
            }
        }
    }
    handleExpansion = () => {
        this.setState({ expanded: !this.state.expanded });
    }
    handleKeyboardAction = (fromKeyboard: boolean) => {
        if (fromKeyboard) { // if keyboard action then scroll to top of list to set focus
            this.setState({ scrollToTop: 0 });
        }
    }
    handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key.toLowerCase() === GeneralNavigationHotKeys.Fab && e.ctrlKey && e.shiftKey && this.fabButtonRef.current) {
            e.preventDefault();
            e.stopPropagation();
            // if focus on Fab Container do nothing.
            if (this.fabRef.current && !this.fabRef.current.contains(document.activeElement)) {
                this.props.timerStore!.rootStore.appStore.setActiveElementBeforeFab(document.activeElement as HTMLElement);
                this.fabButtonRef.current.focus();
            }
        } else {
            handleEscapeKey(e, this.rightPanelRef.current, this.fabRef.current);
        }
    }

    render() {
        const { match, classes, timerStore, t } = this.props;
        const { expanded, scrollToTop } = this.state;
        const {
            selectedTimer,
            onSearchChange,
            loadingTimer,
            // deleteTemplate,
            // newTemplate,
            newTimer,
            filteredTimers,
            searchText,
            openTimerPopOut,
            popOutOpen,
            closePopOut,
            mainWinLoading,
            sortByAlphaNumericToggle,
            toggleAlphaNumericHandler,
            clientFilter,
            getDistinctClients,
            setClientFilter,
            getDistinctMatters,
            matterFilter,
            setMatterFilter,
            updateFilterTodayTimers,
            filterTodayTimersFlag,
            resetSortAndFilterTimers,
            applyingFilter,
            timerLoading,
            playAndStopLoading,
            activeTimerUpdateSteps
        } = timerStore!;
        const disableTimers = timerLoading || !!loadingTimer || !!playAndStopLoading || !!activeTimerUpdateSteps;
        const matterLabel = timerStore!.rootStore.appStore.features.EpochConfigMatterLabel;
        return (
            <Styled.Container disabled={disableTimers}>
                <div>
                    <Styled.Header>
                        <Styled.SearchContainer>
                            <Search
                                style={{ marginRight: '6px' }}
                            />
                            <Input
                                placeholder={t('header.field.search.placeholder')}
                                fullWidth={true}
                                style={{ maxWidth: '60%' }}
                                value={searchText}
                                onChange={e => onSearchChange(e.target.value)}
                                inputProps={{
                                    'data-auto-focus': true
                                }}
                            />
                        </Styled.SearchContainer>
                        <Styled.Title variant="h6">
                            {t('header.title')}
                        </Styled.Title>
                        <Styled.NewActions>
                            <TKConsumer>
                                {(tk: TimeKeeperAssignment) =>
                                    <>
                                        {tk.writable &&
                                            <>
                                                {popOutOpen ?
                                                    <Tooltip title={t('header.action.timers_window.hide')}>
                                                        <IconButton
                                                            onClick={closePopOut}
                                                            className={classes.button}
                                                        >
                                                            <FlipToFront/>
                                                        </IconButton>
                                                    </Tooltip> :
                                                    <Tooltip title={t('header.action.timers_window.show')}>
                                                        <IconButton
                                                            onClick={openTimerPopOut}
                                                            className={classes.defaultButton}
                                                        >
                                                            <FlipToBack/>
                                                        </IconButton>
                                                    </Tooltip>
                                                }
                                                <Tooltip title={t('header.action.add')}>
                                                    <IconButton
                                                        onClick={() => {
                                                            timerStore!.rootStore.appStore.setPreviousActiveElement();
                                                            newTimer();
                                                        }}
                                                        className={classes.defaultButton}
                                                    >
                                                        <Add/>
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title={t('header.action.quick_timer')}>
                                                    <IconButton
                                                        onClick={() => {
                                                            timerStore!.rootStore.appStore.setPreviousActiveElement();
                                                            newTimer(true);
                                                        }}
                                                        className={classes.defaultButton}
                                                    >
                                                        <AddAlarm/>
                                                    </IconButton>
                                                </Tooltip>
                                            </>
                                        }
                                    </>
                                }
                            </TKConsumer>
                            {expanded ?
                                <Tooltip title={t('collapse', { ns: 'common' })}>
                                    <IconButton
                                        onClick={this.handleExpansion}
                                        className={classes.button}
                                    >
                                        <KeyboardArrowUp />
                                    </IconButton>
                                </Tooltip>
                                :
                                <Tooltip title={t('expand', { ns: 'common' })}>
                                    <IconButton
                                        onClick={this.handleExpansion}
                                        className={classes.defaultButton}
                                    >
                                        <KeyboardArrowDown />
                                    </IconButton>
                                </Tooltip>
                            }
                        </Styled.NewActions>
                    </Styled.Header>
                    <Collapse unmountOnExit={true} in={expanded}>
                        <ApiConsumer>
                            {(api: RootAPI) =>
                                <Styled.AdvancedHeader>
                                    <Styled.AutoCompleteFilters>
                                        <AutoCompleteField
                                            label={t('header.filter.client')}
                                            fetch={(search: string) => getDistinctClients(search)}
                                            currentItem={clientFilter ? clientFilter : null}
                                            getItemText={(c: Client) => parseCode(c.name, c.number)}
                                            clearable={true}
                                            onClear={() => setClientFilter(null, (clientFilter === null) ? true : false)}
                                            onSelect={setClientFilter}
                                        />
                                    </Styled.AutoCompleteFilters>
                                    <Styled.AutoCompleteFilters>
                                        <AutoCompleteField
                                            label={t('header.filter.matter', { matterLabel })}
                                            fetch={(search: string) => getDistinctMatters(search, clientFilter ? clientFilter.id : 0)}
                                            currentItem={matterFilter ? matterFilter : null}
                                            getItemText={(m: Matter) => parseCode(m.name, m.number)}
                                            formatItem={MatterItemFormatter}
                                            clearable={true}
                                            onClear={() => setMatterFilter(null, (matterFilter === null) ? true : false)}
                                            onSelect={setMatterFilter}
                                            tooltip={getMatterTooltipText}
                                        />
                                    </Styled.AutoCompleteFilters>
                                    <Tooltip
                                        title={sortByAlphaNumericToggle === undefined ?
                                            t('header.filter.sort_by.ascending')
                                            : sortByAlphaNumericToggle ?
                                                t('header.filter.sort_by.descending')
                                                :
                                                t('header.filter.sort_by.last_modified')
                                        }
                                    >
                                        <Styled.FilterButton onClick={toggleAlphaNumericHandler}>
                                            <SortIcon />
                                        </Styled.FilterButton>
                                    </Tooltip>
                                    <Tooltip
                                        title={filterTodayTimersFlag ?
                                            t('header.filter.show.all')
                                            :
                                            t('header.filter.show.today_only')}
                                    >

                                        <Styled.FilterButton
                                            className={filterTodayTimersFlag ? classes.button : classes.defaultButton}
                                            onClick={updateFilterTodayTimers}
                                        >
                                            <Today />
                                        </Styled.FilterButton>
                                    </Tooltip>
                                    <Tooltip title={t('header.filter.reset')}>
                                        <Styled.FilterButton
                                            className={classes.defaultButton}
                                            onClick={resetSortAndFilterTimers}
                                        >
                                            <Loop />
                                        </Styled.FilterButton>
                                    </Tooltip>
                                </Styled.AdvancedHeader>}
                        </ApiConsumer>
                    </Collapse>
                    <DailyTimerTotals />
                </div>

                <Styled.ContentContainer expanded={expanded}>
                    <Styled.ListContainer square={true}>
                        <AutoSizer>
                            {({ width, height}) => (
                                <List
                                    scrollToIndex={scrollToTop}
                                    height={height}
                                    width={width}
                                    rowHeight={80}
                                    rowCount={filteredTimers.length}
                                    rowRenderer={props => (
                                        <ListRow
                                            {...props}
                                            buttonRef={props.index === 0 ? this.activeButtonRef : undefined}
                                            timerStore={this.props.timerStore!}
                                            handleKeyboardAction={this.handleKeyboardAction}
                                        />
                                    )}
                                />
                            )}
                        </AutoSizer>
                    </Styled.ListContainer>
                    <Styled.FormContainer innerRef={this.rightPanelRef} onKeyDown={this.handleKeyDown}>
                            <Route 
                                path={`${match.url}/:id`} 
                                render={(props) =>
                                    selectedTimer ? <TemplateFormContainer {...props} fabRef={this.fabRef} fabButtonRef={this.fabButtonRef}/> : null
                                }
                            />
                            {(mainWinLoading || applyingFilter) && LoadingDiv()}
                    </Styled.FormContainer>
                </Styled.ContentContainer>
            </Styled.Container>
        );
    }
}
// tslint:disable-next-line:no-any
export default withStyles(styles as any)(withTranslation(['timers', 'common'])(Timers));